import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CountrySelectorCard,
  CtaBanner,
  FaqAccordion,
  FeatureBlock,
  Hero,
  InvestorsGrid,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import {
  accountsConvert,
  accountsHero,
  accountsReceive,
  accountsTransfer,
} from '~/content/accounts';
import { safeSpaceSection, trustedBySection } from '~/content/shared';
import { getDefaultFaq } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

export const Route = createFileRoute('/')({
  loader: () => getDefaultFaq(),
  head: () =>
    pageHeadMeta({
      title: 'Open a Global USD Account and Send Money Today',
      description:
        'Open a global USD account with nsave. Get U.S. account and routing numbers to receive ACH payments and send money internationally with low fees.',
      path: '/',
      inlineStyles: [heroCss],
    }),
  component: AccountsPage,
});

function AccountsPage() {
  const faqContent = Route.useLoaderData();

  return (
    <PageShell>
      <Hero content={accountsHero} showBalanceCard />
      <TextSection content={trustedBySection} />
      <FeatureBlock
        content={accountsReceive}
        imagePosition="left"
        sectionClassName="!py-[10px] max-lg:mb-16"
      />
      <FeatureBlock
        content={accountsTransfer}
        imagePosition="left"
        sectionClassName="!py-[10px] max-lg:mb-16"
        imageOverlay={<CountrySelectorCard />}
      />
      <FeatureBlock
        content={accountsConvert}
        imagePosition="left"
        sectionClassName="!py-[10px] max-lg:mb-16"
      />
      <TextSection content={safeSpaceSection} sectionClassName="max-md:!my-[40px]" />
      <InvestorsGrid />
      <TestimonialGrid />
      <FaqAccordion content={faqContent} />
      <CtaBanner />
    </PageShell>
  );
}
